import axios from 'axios'

export async function cancelTransaction({ transactionId, reasonCode = 998 }) {
  return await axios.post(`v30/transactions/${transactionId}/cancel`, {
    reasonCode,
  })
}
